export class AuthenticationState<T, E = string> {
    private constructor(
        private state: "idle" | "loggingIn" | "loggedIn" | "loggedOut" | "didExpire",
        private data?: T,
        private error?: E
    ) { }

    static idle<T, E = string>(): AuthenticationState<T, E> {
        return new AuthenticationState<T, E>("idle");
    }

    static loggingIn<T, E = string>(): AuthenticationState<T, E> {
        return new AuthenticationState<T, E>("loggingIn");
    }

    static loggedIn<T, E = string>(user: T): AuthenticationState<T, E> {
        return new AuthenticationState<T, E>("loggedIn", user);
    }

    static loggedOut<T, E = string>(): AuthenticationState<T, E> {
        return new AuthenticationState<T, E>("loggedOut");
    }

    map<U>(fn: (data: T) => U): AuthenticationState<U, E> {
        return this.state === "loggedIn"
            ? AuthenticationState.loggedIn<U, E>(fn(this.data!))
            : (this as unknown as AuthenticationState<U, E>);
    }

    static didExpire<T, E = string>(): AuthenticationState<T, E> {
        return new AuthenticationState<T, E>("didExpire");
    }

    getOrElse(defaultValue: T): T {
        return this.state === "loggedIn" ? this.data! : defaultValue;
    }

    getOrNull(): T | null {
        console.log("getOrNull state:", this.state);
        return this.state === "loggedIn" ? this.data! : null;
    }

    get() {
        return this.data;
    }

    match<R>(cases: {
        idle?: () => R;
        loggingIn?: () => R;
        loggedOut?: () => R;
        loggedIn?: (data: T) => R;
        didExpire?: () => R;
    }): R | null {
        switch (this.state) {
            case "idle":
                return cases.idle ? cases.idle() : null;
            case "loggingIn":
                return cases.loggingIn ? cases.loggingIn() : null;
            case "loggedOut":
                return cases.loggedOut ? cases.loggedOut() : null;
            case "loggedIn":
                return cases.loggedIn ? cases.loggedIn(this.data!) : null;
            case "didExpire":
                return cases.didExpire ? cases.didExpire() : null;
        }
    }
}